import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_SE: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrologi',
  components_header_media_multi_content_2: 'Meditation',
  components_header_media_multi_content_3: 'Kärlek',
  components_header_text1: 'Guider',
  components_header_text2: 'Blogg',
  hero_text: 'Hitta klarhet, balans och kontakt.',
  hero_button_text: 'Börja din resa',
  components_ressources_subheader_text: 'Tips och inspiration',
  components_ressources_span_text: 'Den sammanför personliga astrologiska insikter, lugnande meditationsövningar och omtänksam kärleksvägledning för att stödja självupptäckt, emotionell balans och djupare kontakt.',
  components_ressources_card_1_title: 'Meditationstips',
  components_ressources_card_1_text: 'Snabbguide för bättre lugn, andning och fokus.',
  components_ressources_card_2_title: 'Kärleksvägledning',
  components_ressources_card_2_text: 'Enkla tips för att bygga starkare kontakt och emotionell balans.',
  components_ressources_link: 'Upptäck mer',
  components_notes_and_google_title_1: 'Hitta klarhet',
  components_notes_and_google_title_2: 'Inre lugn',
  components_notes_and_google_title_3: 'Hjärtkoppling',
  media_content_section_multi_1_subheader_text: 'Vår podcast',
  media_content_section_multi_2_subheader_text: 'Våra meditationer',
  media_content_section_multi_3_subheader_text: 'Äkta prat om kosmisk romantik',
  page_media_content_menu_antistress: 'Antistress',
  page_media_content_menu_mindfulness: 'Mindfulness',
  page_media_content_menu_energyboost: 'Energiboost',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Grundläggande',
  page_media_content_menu_spirituality: 'Andlighet',
  page_media_content_menu_tarot: 'Tarotkort',
  page_media_content_menu_psychology: 'Psykologi',
  page_media_content_menu_trends: 'Trender',
  page_media_content_menu_compatibility: 'Kompatibilitet',
  page_media_content_menu_love: 'Kärlek',
  text2_section_title: 'BLOGG',
  text2_section_subheader_text: 'Artiklar och insikter',
  text2_section_button_more: 'Ladda mer',
  components_text1_section_title: 'GUIDER',
  components_text1_subheader_text: 'Kosmisk kunskap för daglig inriktning',
  components_text1_span_text: 'Anpassa dig till universums rytmer: utforska en kuraterad samling av djupgående astrologiska och meditativa guider utformade för att väcka inre klarhet, fördjupa självkännedom och stödja din resa mot själslig, himmelsk tillväxt.',
  components_text1_card_1_title: 'Öppen för tystnaden',
  components_text1_card_1_text: 'Börja din resa med grundläggande meditations- och astrologiguider – perfekt för sökare som dras till inre stillhet, kosmiska mönster och personlig insikt.',
  components_text1_card_3_title: 'Länk mellan kropp och själ',
  components_text1_card_3_text: 'Avslöja de djupare lagren av din inre värld. Dessa guider rör sig bortom ytan för att avslöja mening, känslor och medvetna mönster som formar din upplevelse.',
  components_text1_card_2_title: 'Reflektera och integrera',
  components_text1_card_2_text: 'Från känslomässiga blockeringar till planetära cykler – dessa guider erbjuder verktyg för reflektion, läkning och transformation genom medvetna ritualer och astrologisk visdom.',
  components_text1_link: 'Visa alla guider',
  components_footer_text: 'Hitta klarhet, balansera ditt sinne och få kontakt med mening – din plats för astrologi, meditation och kärlek.',
};